<mat-form-field appearance="outline" class="org-picker-field">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    type="text"
    [formControl]="control"
    [matAutocomplete]="orgAuto"
    [attr.data-testid]="inputTestId"
    [attr.aria-label]="label"
  />
  <mat-autocomplete #orgAuto="matAutocomplete" (optionSelected)="onOrgOptionSelected($event)">
    @if (orgLookupAttempted && orgOptions.length === 0) {
      <mat-option disabled [attr.data-testid]="noMatchesTestId">No matching organizations</mat-option>
    } @else {
      @for (option of orgOptions; track option.id) {
        <mat-option [value]="option" [attr.data-testid]="optionTestId">{{ option.name }}</mat-option>
      }
      @if (orgOptionsCapped) {
        <mat-option disabled class="org-picker-capped-hint" [attr.data-testid]="cappedHintTestId">
          Showing the first 20 matches — keep typing to narrow
        </mat-option>
      }
    }
  </mat-autocomplete>
  @if (control.hasError('invalidOption')) {
    <mat-error [attr.data-testid]="errorTestId">Select an organization from the list.</mat-error>
  }
</mat-form-field>
